var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgLogoFull = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 816,
    height: 104,
    viewBox: "0 0 816 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.0896 94.491V60.159H19.2836V94.491H0.0576172V14.6118H19.2836V46.5406H66.0896V14.6118H85.3155V94.491H66.0896Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.773 94.491V14.6118H115.999V94.491H96.773Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.3 96.3221C143.69 96.3221 123.777 79.156 123.777 54.5514C123.777 31.4345 144.033 12.7808 172.185 12.7808C195.531 12.7808 214.643 23.9959 216.932 41.6197L195.531 43.3363C194.616 32.9222 185.232 27.5435 172.185 27.5435C154.676 27.5435 143.232 38.6442 143.232 54.5514C143.232 70.4586 154.791 81.5593 172.3 81.5593C187.292 81.5593 195.989 76.6384 197.934 66.5676H164.518V52.1482C169.553 52.6059 173.673 52.8348 182.485 52.8348H217.046C220.021 79.156 201.253 96.3221 172.3 96.3221Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.528 94.491V60.159H244.722V94.491H225.496V14.6118H244.722V46.5406H291.528V14.6118H310.754V94.491H291.528Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M322.211 94.491V14.6118H343.611L388.815 73.5485C388.815 73.5485 388.358 64.5077 388.358 49.8594V14.6118H407.583V94.491H386.069L340.979 35.5543C340.979 35.5543 341.437 44.5951 341.437 59.2435V94.491H322.211Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M463.553 96.3221C435.629 96.3221 415.488 78.5838 415.488 54.5514C415.488 30.519 435.629 12.7808 463.553 12.7808C491.476 12.7808 511.503 30.519 511.503 54.5514C511.503 78.5838 491.476 96.3221 463.553 96.3221ZM463.553 81.216C480.147 81.216 492.048 70.1153 492.048 54.5514C492.048 38.9875 480.147 27.8869 463.553 27.8869C446.959 27.8869 434.943 38.9875 434.943 54.5514C434.943 70.1153 446.959 81.216 463.553 81.216Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M540.96 94.491V29.2601H508.688V14.6118H592.687V29.2601H560.186V94.491H540.96Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M598.387 94.491V14.6118H667.051V29.2601H617.613V46.5406H659.613V60.159H617.613V79.8427H667.624V94.491H598.387Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M810.75 10.7497C824.101 28.1109 811.118 60.4916 781.751 83.074C752.385 105.656 717.756 109.889 704.406 92.5277C691.055 75.1664 704.038 42.7857 733.404 20.2034C762.77 -2.379 797.399 -6.61155 810.75 10.7497ZM766.531 44.7522C768.781 47.678 766.595 53.1333 761.649 56.937C756.703 60.7406 750.869 61.4523 748.619 58.5265C746.369 55.6007 748.555 50.1454 753.501 46.3417C758.448 42.5381 764.281 41.8264 766.531 44.7522Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-full.c5a2171c7113534d306860a7bab3b100.svg";